const MMnu = localStorage.getItem('globalmenues');
const Permission = localStorage.getItem('permissions');
const Uname = localStorage.getItem('username');
const partnerType = localStorage.getItem('partnerType');
const initialState = MMnu != ''
                    ? {username: JSON.parse(Uname),globalKey:0,globalmenues:JSON.parse(MMnu),partnerType:JSON.parse(partnerType),MyPermission:JSON.parse(Permission)}
                    : {username: '',globalKey:0,globalmenues:{},partnerType:'',MyPermission:[]};

export const common = {
    state: initialState,
    mutations: {
        set_username (state, payload) {
          state.username = payload
          if(payload){
            localStorage.setItem('username',JSON.stringify(payload));
          }  
        },
        set_globalKey (state, payload) {
          state.globalKey = payload
        },
        set_globalmenues (state, payload) {
          state.globalmenues = payload; // Object.assign({}, payload)
          if(payload){
            localStorage.setItem('globalmenues',JSON.stringify(payload));
          }          
        },
        set_permission (state, payload) {
          state.MyPermission = payload; // Object.assign({}, payload)
          if(payload){
            localStorage.setItem('permissions',JSON.stringify(payload));
          }          
        },
        set_partnerType (state, payload) { 
          state.partnerType = payload
          if(payload){
            localStorage.setItem('partnerType',JSON.stringify(payload));
          }  
        },
      },
      getters: {
        username (state) {
          return state.username
        },
        globalKey(state){
          return state.globalKey
        },
        globalmenues (state){
          return state.globalmenues
        },
        partnerType (state){
          return state.partnerType
        },
        Permission (state){
          return state.MyPermission
        }
      }
}
